import Navigation from './app/routes/Navigation';


import { COLORS } from './core/constants/colors';
import { Box, ThemeProvider, autocompleteClasses, createTheme } from '@mui/material';
import { useIdentityStore } from './core/store';
import { useEffect } from 'react';

import { SnackbarProvider } from 'notistack';

import { LicenseInfo } from '@mui/x-license-pro';
// import { useSocketIoClient } from './core/hooks/@io-socket/useSocketIoClient';

// Estilos
import './core/assets/styles/style.scss';
import './core/assets/styles/tailwind.scss';
import '@mui/material/styles';




// Moment en ES
import moment from 'moment';
import 'moment/locale/es';
import 'moment-timezone';

import CustomSnackbar from './app/components/custom-snackbar/CustomSnackbar';
// import SnackbarManager from './app/components/snackbar-manager/SnackbarManager';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { SnackbarManager, StoreCleaner } from './app/components';
import "./core/i18n/118n";
import { useTranslation } from 'react-i18next';
import themeLight from "./core/assets/theme/light";

// Establecer zona horaria global, por ejemplo:
moment.tz.setDefault("Europe/Madrid"); // O la zona horaria que necesites
moment.updateLocale('en', {
  week: {
    dow: 1, // Define el lunes como el primer día de la semana
    doy: 4, // El primer día del año debe ser un jueves o el lunes más cercano al 1 de enero
  },
});

moment.updateLocale('es', {
  week: {
    dow: 1, // Define el lunes como primer día de la semana (0 para domingo, 1 para lunes)
  },
});

// moment.locale('es');


// LicenseInfo.setLicenseKey('f4cefc7a2d6a667effc50569bad83c53Tz04NTkwMixFPTE3NDEzNjg5MzUwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');
LicenseInfo.setLicenseKey('0e5020006e09f3d9b950df9870d0ca56Tz0xMTEyMDYsRT0xNzc1ODY1NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');



// TODO: Quita console.log en production
// if (process.env.NODE_ENV === 'production') {
//   console.log = function () { };
// }

function App() {
  const loadIdentity = useIdentityStore(state => state.loadIdentity);
  const identity = useIdentityStore(state => state.identity);
  const { i18n } = useTranslation(); // Usar el hook de i18n

  useEffect(() => {
    // Carga la identidad al iniciar la app
    if (!identity) {
      loadIdentity();
    }
  }, [loadIdentity, identity]);


  // Sincronizar el idioma de Moment.js con el idioma de i18next
  useEffect(() => {
    // Cambia el locale de Moment.js según el idioma de i18next
    moment.locale(i18n.language); // Usa el idioma actual de i18n
    console.log("Idioma actual para Moment.js:", i18n.language);
  }, [i18n.language]); // Se ejecutará cada vez que cambie el idioma



  console.log("API APP: ", process.env.REACT_APP_API_URL_MS_AUTH);
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <ThemeProvider theme={themeLight}>
        <SnackbarProvider maxSnack={3}>
          <SnackbarManager />
          {/* <ToastApp /> */}
          <Navigation />

        </SnackbarProvider>
      </ThemeProvider>
    </LocalizationProvider >
  )
}

export default App
